module.exports = __webpack_public_path__ + "static/media/browse-chapter-image.ec1a2164.png";